export type VehicleServiceType = 'maintenance' | 'repair' | 'tire' | 'other';

export enum VehicleServiceStatus {
    Ordered = 'ordered',
    InProgress = 'inProgress',
    WaitingForParts = 'waitingForParts',
    Completed = 'completed',
    Cancelled = 'cancelled',
}

export interface IVehicleService {
    createdAt: Date;
    createdBy: string;
    vehicleUid: string;
    dealerId: string;
    serviceType: VehicleServiceType;
    status: VehicleServiceStatus;
    description: string;
    preferredDate?: string;
    currentMileage?: number;
    currentHours?: number;
    plannedFinish?: string;
    finishedAt?: Date;
    serviceTasks?: string[];
    updatedAt?: Date;
    updatedBy?: string;
}

export type VehicleService = IVehicleService & { id: string };
